export const environment = {
  production: false,
  indexable: false, // Entorno dev no es indexable

  name: 'development',
  apiUrl: 'https://wikidigital.shck-dev.com/api',
  msalConfig: {
    auth: {
      clientId: '1701a378-5109-4e26-95f9-756024fbe492',
      authority: 'https://login.microsoftonline.com/f3211d0e-125b-42c3-86db-322b19a65a22',
      tenantId: 'f3211d0e-125b-42c3-86db-322b19a65a22', // <-- Añadido para fácil acceso
    },
  },
  apiConfig: {
    scopes: ['user.read'],
    uri: 'https://graph.microsoft.com/v1.0/me',
  },
};
